export const IMAGE_NODE_IMAGE_PANEL = 'image';
